// Module
var code = "<ul>\r\n    <li ng-repeat=\"msg in messages\" ng-class=\"msg.highlight ? 'error-highlight' : ''\">\r\n        {{msg.text}}\r\n    </li>\r\n</ul>\r\n";
// Exports
module.exports = code;